import Cookies from 'js-cookie';

import { httpClient } from '@/config/httpClient';

import { RequestApprovalReviewForm } from '../schemas/RequestApprovalReviewSchema';

export const postRejectRequestApproval = async (
  data: RequestApprovalReviewForm & { batchId: string },
) => {
  const formData = new FormData();

  formData.append('file', data.file);

  return httpClient.post(
    `/batch/approval-request/reject/${data.batchId}?comment=${data.comment}`,
    formData,
    {
      headers: {
        Account: Cookies.get('accountId-access-batch'),
        Authorization: `Bearer ${Cookies.get('jwt-access-batch')}`,
        'Content-Type': 'multipart/form-data',
      },
    },
  );
};
